import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lastLanguageChange, setLastLanguageChange] = useState(true);

  return (
    <LanguageContext.Provider value={{ lastLanguageChange, setLastLanguageChange }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => {
  return useContext(LanguageContext);
};
